import React from 'react';
import './ShippingPolicy.css';

const ShippingPolicy = () => {
  return (
    <div className="shipping-page">
      <section className="shipping-hero">
        <div className="container">
          <h1>Shipping Policy</h1>
          <p>Fast & Reliable Delivery Across Sweden</p>
        </div>
      </section>

      <div className="shipping-content">
        <div className="shipping-intro">
          <p>
            MunchUps is committed to delivering your orders quickly and safely. This Shipping Policy outlines 
            our delivery areas, shipping costs, delivery times, and procedures for handling various shipping situations. 
            By placing an order through our website, you agree to the terms outlined below.
          </p>
          <p>
            <strong>Last updated: January 22, 2026</strong>
          </p>
        </div>

        <section className="shipping-section">
          <h2>1. Overview</h2>
          <p>
            This Shipping Policy applies to all orders placed with MunchUps (NordicBloom AB), a company selling imported 
            packaged snack products sourced from countries outside the European Union (EU). 
            We sell to both retail stores (B2B) and private individuals/consumers (B2C).
          </p>
          <p>By placing an order with us, you agree to the terms outlined in this Shipping Policy.</p>
        </section>

        <section className="shipping-section">
          <h2>2. Shipping Destinations</h2>
          
          <p>We currently ship:</p>
          <ul>
            <li>Only within Sweden</li>
          </ul>

          <p>
            If you want the orders to be shipped outside Sweden, Please feel free to reach us at <strong><a href="mailto:info.munchups@gmail.com">info.munchups@gmail.com</a></strong> to discuss potential options. We are open to exploring international shipping possibilities in the future.
          </p>
        </section>

        <section className="shipping-section">
          <h2>3. Order Processing Time</h2>

          <ul>
            <li>Orders are typically processed within 1 - 3 business days after payment confirmation.</li>
            <li>Business days exclude weekends and public holidays.</li>
            <li>During peak periods or due to customs delays, processing times may be extended.</li>
          </ul>

          <p>You will receive a confirmation email once your order has been dispatched.</p>
        </section>

        <section className="shipping-section">
          <h2>4. Shipping Methods & Delivery Times</h2>
          <p>
            We try to deliver your orders as quickly as possible. Estimated delivery times begin after dispatch, not at the time of order:
          </p>
          <p>Our warehouse operates on Monday - Friday during standard business hours, except on national holidays at which time the warehouse will be closed. In these instances, we take steps to ensure shipment delays will be kept to a minimum.</p>
          <ul>
            <li><strong>Within Sweden:</strong>approx. 2-3 business days</li>
            <li><strong>Outside Sweden:</strong>Please contact us on info.munchups@gmail.com</li>
            <li>You can choose to either wait for restocking or receive a refund for those items</li>
          </ul>

          <p>
            Delivery times are estimates and may vary due to:
          </p>
          <ul>
            <li>Stock availability issues</li>
            <li>Local carrier delays</li>
            <li>Situations beyond our control (e.g., weather, public holidays, or anyother unforeseen circumstances)</li>
          </ul>

          <p>We cannot guarantee delivery by a specific date.</p>
        </section>

        <section className="shipping-section">
          <h2>5. Shipping Costs - Private Individual/Consumers</h2>
          <p>
            Shipping costs are as below (Applicable for <strong><u>Private Individuals/Consumers</u></strong> in Sweden):
          </p>
          <h3>Stockholm</h3>
          <p>Not applicable for <strong>Södertalje, Uppsala, Ekerö, Kunsängen, Nörrtälje, Värmdö, Häninge, Tyresö, Tumba</strong></p>
          <ul>
            <li>We offer home delivery for all orders above 100 SEK per order.</li>
            <li>We offer pickup at our warehouse for all orders.</li>
            <li>We offer home delivery for all orders below 100 SEK with a delivery fee of 29 SEK per order.</li>
          </ul>
          <h3>Södertalje, Uppsala, Ekerö, Kunsängen, Nörrtälje, Värmdö, Häninge, Tyresö, Tumba</h3>
          <ul>
            <li>We offer free delivery for all orders above 350 SEK per order.</li>
            <li>Orders will be delivered to nearest pickup point. Estimated delivery time is around 4-5 business days.</li>
            <li>For all orders below 350 SEK, a delivery fee of 59 SEK per order will be added.</li>
          </ul>
          <h3>Rest of Sweden</h3>
          <ul>
            <li>We offer free delivery for all orders above 1000 SEK per order.</li>
            <li>Orders will be delivered to nearest pickup point. Estimated delivery time is around 4-5 business days.</li>
            <li>For all orders below 1000 SEK, a delivery fee of 159 SEK per order will be added.</li>
          </ul>
          <p>
            <i>For corporate orders please contact us at info.munchups@gmail.com to discuss shipping options and costs. We are open to exploring different delivery arrangements for our B2B customers.</i>
          </p>
        </section>

        <section className="shipping-section">
          <h2>6. Shipping - Wholesale / Store Orders</h2>

          <p>
            For retail store or bulk orders:
          </p>
          <ul>
            <li>Shipping terms, and delivery arrangements may differ from private individual/consumers orders.</li>
          </ul>
          <p>Please contact us directly for B2B shipping arrangements.</p>
        </section>

        <section className="shipping-section">
          <h2>7. Failed Delivery &amp; Returned Packages</h2>

          <p>
            Packages may be returned due to:
          </p>
          <ul>
            <li>Incorrectly delivered address.</li>
            <li>Failure to collect the package within the carrier&apos;s timeframe.</li>
          </ul>

          <p>
            In such cases,
          </p>
          <ul>
            <li>For Private Individual/Consumer orders (eligible for free delivery) that are returned, a delivery fee of 29kr will be deducted and remaining amount will be returned.</li>
            <li>For all other orders, original shipping fees are non-refundable.</li>
            <li>Refunds (if applicable) will exclude shipping and handling costs.</li>
          </ul>
        </section>

        <section className="shipping-section">
          <h2>8. Risk of Loss &amp; Damaged Shipments</h2>

          <ul>
            <li>Risk of loss transfers to the customer once the order has been handed over to the carrier.</li>
            <li>If your order arrives damaged, you must notify us within 48 hours of delivery and provide clear photos of the packaging and products.</li>
          </ul>

          <p>
            We reserve the right to assess claims on a case-by-case basis.
          </p>
        </section>
        <div className="shipping-footer">
          <p>
            By using our website, you acknowledge that you have read and understood this Shipping policy 
            and agree to it.
          </p>
          <p>
            MunchUps reserves the right to update this Shipping Policy at any time. Changes will be effective 
            immediately upon posting to our website. Your continued use of our services following any changes indicates your acceptance of the updated Shipping Policy.
          </p>
          <p>
            <strong>Last Updated: January 22, 2026</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
